<app-menu [hasChanges]="loadMenu" [title]="'Registro de Ventas ' + (selectedStore?.nombreTienda ??'')"></app-menu>
<app-loading [show]="load"></app-loading>
<section id="divIni" class="p-fluid pt-0 p-2 image-close-up ">
    <div class="flex justify-content-between">
        <div class="flex flex-wrap gap-4">
            <div class="flex items-center">
                <p-radioButton name="tipoTransaccion" inputId="optVenta" value="1" [(ngModel)]="optTransaccion"
                    (click)="clear()">
                </p-radioButton><label for="optVenta" class="ml-2">Generar Venta</label>
            </div>
            <div class="flex items-center">
                <p-radioButton name="tipoTransaccion" inputId="optDevolucion" value="2" [(ngModel)]="optTransaccion"
                    (click)="clear()">
                </p-radioButton>
                <label for="optDevolucion" class="ml-2">Generar devolución</label>
            </div>
        </div>
    </div>
    <!--Pantalla para mostrar las cotizaciones en proceso-->
    <div *ngIf="lsCotizacion.length > 0" class="p-message p-message-warn m-2">Tienes {{lsCotizacion.length}}
        {{lsCotizacion.length > 1?'Cotizaciones':
        'Cotización'}}
        <div class="flex flex-wrap" *ngFor="let row of lsCotizacion">
            <div class="w-9">
                Nro. de cotización: {{row.idCotizacion}} | Nro. de items: {{row.detalleCotizacions.length}}
                | Subtotal: {{row.subtotal | currency}} | Impuesto: {{row.impuesto | currency}}
                | Total: {{(row.subtotal + row.impuesto) | currency}}
            </div>
            <div class="w-3 flex align-items-center">
                <button pButton label="Cargar cotización" icon="pi pi-eye" (click)="setDetailQuotation(row)"></button>
            </div>
        </div>

    </div>
    <div class="flex" *ngIf="formVenta.controls.nombres.value ??'' !=''">
        <div class="w-full">
            <hr>
            <div class="flex flex-wrap">
                <div class="w-full md:w-6 text-center uppercase">Cliente:<b>
                        {{(formVenta.controls.tipo.value?.idTipoIdentificacion) ==3 ?
                        formVenta.controls.razonSocial.value : formVenta.controls.nombres.value}}</b>
                </div>
                <div class="w-full md:w-6 text-center">Cupo asignado:{{vlrCupoAsignado | currency}} | Cartera:
                    <b>{{vlrCartera |currency}}</b> | <span class="text-green-700 font-bold">Cupo disponible:
                        {{vlrCupoDisponible | currency}}</span>
                </div>
            </div>
            <hr>
        </div>
    </div>
    <div class="flex sticky top-menu bg-white">
        <div class="w-full flex pt-1 align-items-center" *ngIf="optTransaccion==1">
            <div class="w-full">
                <p-autoComplete id="busqueda" [tabindex]="1" [suggestions]="resultsSKU" #autocomplete
                    (completeMethod)="searchItem($event)" field="descripcionCorta" [minLength]="1"
                    (onSelect)="searchItemView($event)" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="fieldSearch" placeholder="Ingrese el código o el nombre del producto" class="w-full"
                    [autofocus]="true"></p-autoComplete>
                <button pButton class="p-button p-button-link pt-0" (click)="displayInfoECommerce=true;"
                    label="Importar ventas tienda virtual"></button>
            </div>
            <div class="flex align-items-center" *ngIf="optTransaccion==1">
                <div class="hidden md:flex flex-row-reverse gap-4">
                    <button pButton label="Cliente" icon="pi pi-users" class="p-button p-button-outlined w-auto"
                        (click)="displayInfoClient = true"></button>
                </div>
                <!--Mobil-->
                <div class="flex md:hidden flex-row-reverse">
                    <button pButton icon="pi pi-users" [rounded]="true" class="p-button p-button-outlined"
                        (click)="displayInfoClient = true"></button>
                </div>
                <div *ngIf="listStores.length>0">
                    <button pButton icon="pi pi-pencil" class="p-button-success" [rounded]="true" [outlined]="true"
                        (click)="divStoreSelection = true"></button>
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="optTransaccion==2">
            <div class="p-inputgroup w-full">
                <p-inputNumber buttonLayout="horizontal" spinnerMode="horizontal" class="w-full"
                    [(ngModel)]="idComprobante" placeholder="Digite el número de comprobante de pago" pAutoFocus
                    [autofocus]="true">
                </p-inputNumber>
                <button pButton label="Buscar" icon="pi pi-search" class="p-button p-button-success"
                    (click)="getDetalleVenta()"></button>
            </div>
        </div>
    </div>
    <div class="min-h-screen">
        <div class="flex flex-wrap align-items-start mt-3" *ngIf="listBuy.length > 0">
            <div class="w-full md:w-8 flex flex-wrap align-items-start p-2">
                <div class="w-full flex border-bottom-2 border-200 p-2 mb-2 uppercase border-round-top">
                    <span class="w-full text-center">Detalle de productos</span>
                </div>
                <div id="item{{index}}" class="w-full flex flex-wrap border-bottom-2 border-200 pb-2 align-items-center"
                    *ngFor="let prod of listBuy; let index =index">
                    <!-- Detalle -->
                    <div class="hidden md:flex w-1 text-center ">
                        <!-- Imagen -->
                        <img src="{{prod.productoImagenes.length > 0 ? prod.image?.thumbnailImageSrc :'assets/img/noImg.png'}}"
                            style="width:50px" alt="">
                    </div>
                    <div class="w-6 md:w-5 text-left">
                        <div><b>{{prod.descripcionCorta}}</b><br>
                            <span class="text-xs">SKU:{{prod.codBarras}}<br>
                                <b>Unidad de presentación:</b> {{prod.unidadPresentacion==''? 'Unidad':
                                prod.unidadPresentacion}} <br>
                                <b> Marca:</b> {{prod.marca}}</span>
                            <span [innerHTML]="prod.error"></span>
                        </div>
                    </div>
                    <div class="w-6 md:w-3 text-center">
                        <div class="mx-auto w-full">
                            <span class="number">
                                <p-inputNumber [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal"
                                    decrementButtonClass="p-button p-button-warning btn-custom-icon"
                                    incrementButtonClass="p-button p-button-warning btn-custom-icon" [min]="0"
                                    [max]="100000" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                    (onBlur)="getTotal()" (onInput)="getTotal()" [(ngModel)]="prod.cantidad"
                                    [inputStyle]="{'font-size': '0.75rem'}">
                                </p-inputNumber>
                            </span>
                            <span class="text-xs" *ngIf="optTransaccion==1">Inventario Disponible: {{prod.inventory}}
                                Disp. {{prod.inventory -
                                prod.cantidad}}
                            </span>
                        </div>
                    </div>
                    <div class="w-full md:w-3 text-right flex flex-row">
                        <div class="w-11">
                            <div class="text-xs"><b>Prec. Unit. sin Impto:</b>
                                {{(prod.precioProducto.preciosinIMPTOPromo >
                                prod.precioProducto.preciosinIMPTO ?
                                prod.precioProducto.preciosinIMPTO: prod.precioProducto.preciosinIMPTOPromo ) |
                                currency}}
                            </div>
                            <!-- Precio Unitario-->
                            <div class="text-xs"><b>Prec. Unit. con Impto:</b> {{(prod.precioProducto.precioPromocion >
                                prod.precioProducto.precio ?
                                prod.precioProducto.precio: prod.precioProducto.precioPromocion ) | currency}}
                            </div>
                            <div class="text-xs font-bold">Valor Total: {{(prod.cantidad *
                                (prod.precioProducto.precioPromocion
                                >
                                prod.precioProducto.precio ? prod.precioProducto.precio:
                                prod.precioProducto.precioPromocion)) | currency}}</div>
                        </div>
                        <div class="w-1 flex align-items-center p-1" *ngIf="optTransaccion==1">
                            <span class="cursor-pointer bg-green-700 p-1 border-round"><i
                                    class="pi pi-pencil text-white text-xs" (click)="cambioPrecio(index)"></i></span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="w-full md:w-4 border-1 border-300 border-round">
                <div class="text-center">
                    <h3 class="uppercase">Resumen venta</h3>
                </div>
                <div class="flex flex-column pl-3 pr-3">
                    <div class="flex justify-content-between">
                        <div class="text-left">
                            <b>Nro. Items:</b>
                        </div>
                        <div class="text-right">
                            {{listBuy.length}}
                        </div>
                    </div>
                    <div class="flex justify-content-between">
                        <div>
                            <b>SubTotal:</b>
                        </div>
                        <div>
                            {{subtotal | currency}}
                        </div>
                    </div>
                    <div class="flex justify-content-between">
                        <div>
                            <b>Impuesto:</b>
                        </div>
                        <div>
                            {{impuesto | currency}}
                        </div>
                    </div>
                    <div class="w-full">
                        <hr>
                    </div>
                    <div class="flex justify-content-between">
                        <div>
                            <h2 class="p-0 m-0"><b>Total:</b></h2>
                        </div>
                        <div>
                            <h2 class="p-0 m-0"><b> {{(subtotal + impuesto) | currency}}</b> </h2>
                        </div>
                    </div>
                    <div class="w-full">
                        <hr>
                    </div>
                    <div class="flex justify-content-between">
                        <div>
                            <b>Valor faltante:</b>
                        </div>
                        <div>
                            <b>{{valorFaltante | currency}}</b>
                        </div>
                    </div>
                    <div class="w-full">
                        <hr>
                    </div>
                    <!--Section para personalización de la orden-->
                    <div class="w-full" *ngIf="(infoParametrizacion?.customOrd ?? false)">
                        <p class="m-0 p-0 font-bold">Personalizar número de órden:</p>
                        <div class="flex flex-row">

                            <div class="w-4">
                                <input type="text" [maxLength]="10" pInputText placeholder="Prefijo"
                                    [(ngModel)]="customOrdPrefijo" class="max-h-2rem" />
                            </div>
                            <div class="w-8">
                                <input type="text" [maxLength]="20" pInputText placeholder="Numero"
                                    [(ngModel)]="customOrdNumber" class="max-h-2rem" />
                            </div>
                        </div>
                    </div>
                    <!--End Section-->
                    <div class="w-full">
                        <hr>
                    </div>
                    <div *ngIf="optTransaccion==1" class="w-full text-center cursor-pointer"
                        (click)="descuentoGeneral()">
                        <span>¿Desea aplicar un descuento para el total de la
                            órden?</span>
                    </div>
                    <div class="flex flex-column" *ngIf="optTransaccion==1">
                        <div class="text-center">
                            <h3 class="uppercase">Forma de pago</h3>
                        </div>
                        <div class="w-full">
                            <p-autoComplete [dropdown]="true" [(ngModel)]="selectedMethod" size="small"
                                [suggestions]="metodoPagoFilter" (completeMethod)="filterMetodo($event)" field="label"
                                [multiple]="true" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}">
                            </p-autoComplete>
                        </div>
                        <div
                            *ngIf="selectedMethod.length > 1 || (selectedMethod.length ==1 && selectedMethod[0].idVentaMetodoPago > 1)">
                            <div class="flex flex-wrap borderBottom gap-2" *ngFor="let row of selectedMethod">
                                <div class="flex flex-1 flex-column" *ngIf="selectedMethod.length >1">
                                    <label class="pt-1 m-0 p-0">Digite el valor en {{row.label}}&nbsp;
                                        {{row.idVentaMetodoPago == 10
                                        ? 'Cupo Disponible ' + (vlrCupoDisponible | currency) : ''}}</label>
                                    <p-inputNumber placeholder="Valor en {{row.label}}" [(ngModel)]="row.valor"
                                        mode="currency" currency="USD" [minFractionDigits]="0" locale="en-US"
                                        size="small" (onInput)="getFaltante($event, row.label)"></p-inputNumber>
                                </div>
                                <div class="flex flex-column"
                                    *ngIf="row.idVentaMetodoPago>1 && row.idVentaMetodoPago != 10">
                                    <label class="pt-1 m-0 p-0">Digite referencia {{row.label}}</label>
                                    <input type="text" placeholder="Referencia de pago" pInputText pSize="small"
                                        [(ngModel)]="row.referencia" />
                                </div>
                            </div>
                        </div>
                        <div *ngIf="selectedMethod.length==1 && selectedMethod[0].idVentaMetodoPago==1">
                            <span class="flex align-items-end">
                                <div class="flex flex-column w-full">
                                    <label for="">Valor Recaudado</label>
                                    <p-inputNumber placeholder="Valor recibido" mode="currency" currency="USD"
                                        locale="en-US" [minFractionDigits]="0"
                                        (onInput)="getFaltante($event, 'recaudo')" size="small"
                                        [(ngModel)]="valorRecaudo">
                                    </p-inputNumber>
                                </div>
                                <button pButton icon="pi pi-times"
                                    (click)="valorRecaudo=0;getFaltanteEfectivo()"></button>
                            </span>
                            <div class="hidden md:flex flex-wrap justify-content-center mt-2">
                                <div class="w-auto p-1 text-center">
                                    <button pButton class="p-button p-button-success p-3" label="$5.000"
                                        (click)="valorRecaudo =valorRecaudo+5000; getFaltanteEfectivo()"></button>
                                </div>
                                <div class="w-auto p-1 text-center">
                                    <button pButton class="p-button p-button-success p-3" label="$10.000"
                                        (click)="valorRecaudo =valorRecaudo+10000; getFaltanteEfectivo()"></button>
                                </div>
                                <div class="w-auto p-1 text-center">
                                    <button pButton class="p-button p-button-success p-3" label="$20.000"
                                        (click)="valorRecaudo =valorRecaudo+20000; getFaltanteEfectivo()"></button>
                                </div>
                                <div class="w-auto p-1 text-center">
                                    <button pButton class="p-button p-button-success p-3" label="$50.000"
                                        (click)="valorRecaudo =valorRecaudo+50000; getFaltanteEfectivo()"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Selección de vendedor -->
                <div class="w-full pl-3 pr-3" *ngIf="optTransaccion==1 && vendedor.length > 1">
                    <label>Selección de Vendedor</label>
                    <p-select optionLabel="label" [(ngModel)]="selectedSales" optionValue="id" [options]="vendedor"
                        placeholder="Seleccione el vendedor"></p-select>
                </div>
                <!-- Canal de Venta -->
                <div class="w-full pl-3 pr-3" *ngIf="optTransaccion==1 && listCanalVenta.length > 1">
                    <label>Canal de venta</label>
                    <p-select optionLabel="descripcion" [(ngModel)]="selectedListCanalVenta" [options]="listCanalVenta"
                        placeholder="Seleccione el canal de venta"></p-select>
                </div>

                <div class="w-full text-center flex flex-column-reverse pt-2 pl-3 pr-3">
                    <button pButton class="p-button p-button-danger" icon="pi pi-times-circle" label="Cancelar"
                        (click)="reload()"></button> <br>
                    <button #btnProcesar pButton class="p-button p-button-success" icon="pi pi-check"
                        label="Procesar {{optTransaccion ==2 ? 'nota crédito' : 'venta'}}"
                        (click)="optTransaccion==1 ? procesarVenta() : procesarDevolucion()"></button>
                </div>
            </div>
        </div>
    </div>
</section>
<p-toast>

</p-toast>
<p-dialog header="PROCESAMIENTO EXITOSO" [(visible)]="display" [modal]="true" [style]="{width: '80vw'}"
    (onHide)="reload()" [closable]="true">
    <h3 class="uppercase">Venta realizada Nro. {{idVenta== 0 ? 'Procesando ...': idVenta}}</h3>
    <span [innerHtml]="messageDiv"></span>

    <div *ngIf="!registeredCustomer">
        <h4 class="uppercase">Información del cliente</h4>
        <p>Los campos acompañados con un * (asterisco) son obligatorios.</p>
        <!-- // ya registrado desde el inicio no se puede personalizar -->

        <form [formGroup]="formVenta">
            <div class="flex flex-wrap p-2">
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Tipo de identificación <span class="text-xs text-red-700">*</span></label>
                    <p-select [options]="listIdentificationType" optionLabel="descripcion" (onChange)="searchClient()"
                        size="small" placeholder="Tipo de identificación" formControlName="tipo"></p-select>
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Nro. de identificación <span class="text-xs text-red-700">*</span> <span
                            class="text-xs" *ngIf="formVenta.value.tipo?.idTipoIdentificacion ==3">
                            Ingrese la información sin puntos y sin dígito de verificación</span></label>
                    <div class="p-inputgroup">
                        <input pInputText type="text" class="w-full" placeholder="Nro. de Identificación" size="small"
                            formControlName="identificacion" autocomplete="off" (keyup)="clearFormCliente()"
                            (blur)="searchClient()">
                        <div class="p-inputgroup-addon">
                            <label>{{digito??''}}</label>
                        </div>
                    </div>

                </div>
                <div class="w-full md:w-6 p-1" *ngIf="formVenta.value.tipo?.idTipoIdentificacion ==3">
                    <label class="pb-2">Razón Social <span class="text-xs text-red-700">*</span></label>
                    <input pInputText type="text" class="w-full uppercase" placeholder="Razon Social" pSize="small"
                        formControlName="razonSocial" autocomplete="off">
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Contacto <span class="text-xs text-red-700">*</span></label>
                    <input pInputText type="text" class="w-full uppercase" placeholder="Nombres y Apellidos"
                        pSize="small" formControlName="nombres" autocomplete="off">
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Correo electrónico <span class="text-xs text-red-700">*</span></label>
                    <input pInputText type="text" class="w-full lowercase" placeholder="Correo Electrónico"
                        pSize="small" formControlName="correo">
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Dirección</label>
                    <input pInputText type="text" class="w-full" placeholder="Dirección" pSize="small"
                        formControlName="direccion">
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Departamento</label>
                    <p-select [options]="listDptos" [filter]="true" optionLabel="nombreDepartamento" size="small"
                        placeholder="Departamento" formControlName="departamento" (onChange)="loadCities()"></p-select>
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Ciudad</label>
                    <p-select [options]="listCities" [filter]="true" optionLabel="nombreCiudad" size="small"
                        placeholder="Ciudad" formControlName="ciudad"></p-select>
                </div>
                <div class="w-full md:w-6 p-1">
                    <label class="pb-2">Nro. de teléfono</label>
                    <input pInputText type="text" class="w-full" placeholder="Nro. de celular" pSize="small"
                        formControlName="telefono">
                </div>
            </div>
        </form>
    </div>

    <h4>Opciones de notificación de la venta</h4>

    <div class="flex align-items-center">
        <p-radioButton name="notificacion" value="3" inputId="notificacionPrint" [(ngModel)]="optNotificacion">
        </p-radioButton>
        <label for="notificacionEmail">&nbsp;Impresion</label>
    </div>
    <div class="flex align-items-center">
        <p-radioButton name="notificacion" value="1" inputId="notificacionEmail" [(ngModel)]="optNotificacion">
        </p-radioButton>
        <label for="notificacionEmail">&nbsp;Notificación por correo electrónico</label>
    </div>
    <div class="flex align-items-center">
        <p-radioButton name="notificacion" value="2" inputId="notificacionCel" [(ngModel)]="optNotificacion">
        </p-radioButton>
        <label for="notificacionCel">&nbsp;Notificación por Whatsapp</label>
    </div>
    <!-- Solo se activa la opción de Fadcturación electrónica si es estado 2: voluntario -->
    <div class="flex align-items-center" *ngIf="(selectedStore.idTiendaNavigation?.processTypeFe ??3)==2">
        <p-radioButton name="notificacion" value="4" inputId="notificacionCel" [(ngModel)]="optNotificacion">
        </p-radioButton>
        <label for="notificacionCel">&nbsp;Facturación electrónica</label>
    </div>

    <span [innerHtml]="msgVenta"></span>

    <ng-template #footer>
        <div class="pt-3">
            <button pButton icon="pi pi-check" label="{{optNotificacion ==3 ?'Imprimir':'Enviar Notificación'}}"
                class="p-button p-button-success" (click)="setCliente()"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Cambio de precio producto" [(visible)]="displayPrecio" [modal]="true"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}">
    <h4>Digite el precio del producto final o relacione el porcentaje de descuento
        {{(itemSKU?.detalleListaPrecios??[]).length> 0 ? 'o seleccione de la lista de
        precios':''}}<br><span class="text-xs">Estos precios relacionados deben tener impuesto incluido</span>
    </h4>

    <div class="flex flex-wrap gap-4 pb-2">
        <div class="flex items-center">
            <p-radioButton name="optionNumber" value="1" (onClick)="itemSKU.precioFinal=null;"
                [(ngModel)]="priceDiscountType" inputId="ingredient1" />
            <label for="ingredient1" class="ml-2">Precio</label>
        </div>

        <div class="flex items-center">
            <p-radioButton name="optionNumber" value="2" (onClick)="itemSKU.precioFinal=null;"
                [(ngModel)]="priceDiscountType" inputId="ingredient2" />
            <label for="ingredient2" class="ml-2">Porcentaje <span class="text-xs">de descuento</span></label>
        </div>
    </div>

    <div *ngIf="(itemSKU?.detalleListaPrecios??[]).length> 0 && priceDiscountType==1">
        <p-select optionLabel="nameListPrices" [(ngModel)]="itemSKU.selectedListPrices"
            [options]="itemSKU.detalleListaPrecios" placeholder="Seleccione la lista de precios"
            (onChange)="itemSKU.precioFinal = itemSKU?.selectedListPrices?.precio" [filter]="true"></p-select>
    </div>
    <div class="text-left">
        <p><b>{{itemSKU.descripcionCorta}}</b><br>
            <b>Código producto :</b> {{itemSKU.codBarras}}<br>
        </p>
        <div class="text-center">
            <p-inputNumber placeholder="{{priceDiscountType==1?'Relacione precio nuevo':'Relacione porcentaje'}}"
                locale="en-US" prefix="{{priceDiscountType==1?'$':''}}" suffix="{{priceDiscountType==2?'%':''}}"
                [(ngModel)]="itemSKU.precioFinal"></p-inputNumber>
        </div>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Procesar cambio" class="p-button p-button-success"
            (click)="setCambioPrecio()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Mensaje informativo" [(visible)]="bloqueo" [modal]="true" [dismissableMask]="false"
    [closeOnEscape]="false" [closable]="false">
    <div>
        <span [innerHtml]="msgInicial"></span>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Cerrar" class="p-button p-button-danger"
            (click)="redirigir()"></button>
    </ng-template>
</p-dialog>

<!--Selección de tienda-->
<p-dialog header="Selección de ubicación de inventario" [(visible)]="divStoreSelection" [modal]="true"
    [dismissableMask]="false" [closeOnEscape]="false" [closable]="false" [style]="{height: '400px'}">
    <div>
        <label>Selección de ubicación</label>
        <p-select optionLabel="nombreTienda" [(ngModel)]="selectedStore" [options]="listStores"
            placeholder="Seleccione la ubicación"></p-select>

        <div class="p-message p-message-success" *ngIf="!!selectedStore?.nombreTienda"> Ha elégido la ubicación
            {{selectedStore?.nombreTienda}}</div>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check-circle" label="Cerrar" class="p-button p-button-danger"
            (click)="divStoreSelection=false;volver()"></button>
        |
        <button pButton icon="pi pi-check-circle" label="Continuar" class="p-button p-button-success"
            (click)="eventSelectedStore();"></button>
    </ng-template>
</p-dialog>


<p-dialog header="Aplicar descuento general" [(visible)]="displayDescuento" [modal]="true">
    <div class="w-full">
        <label>Relacione el porcentaje de descuento</label>
        <p-inputNumber placeholder="Porcentaje descuento" [max]="50" [step]=1 suffix="%" [className]="'w-full'"
            [(ngModel)]="valorDescuentoGeneral"></p-inputNumber>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Cerrar" class="p-button p-button-danger"
            (click)="displayDescuento=false;"></button>
        <button pButton icon="pi pi-check" label="Restaurar valores sin descuentos" class="p-button p-button-warning"
            (click)="setResetDiscount()"></button>
        <button pButton icon="pi pi-check" label="Procesar cambio" class="p-button p-button-success"
            (click)="setDescuentoGeneral()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Visualizar consolidado de compra" [(visible)]="displaySummary" [modal]="true"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
    <div class="grid borderBottom mt-2" *ngFor="let item of listBuy; let i = index">
        <div class="col-1">#{{i+1}}</div>
        <div class="col-11 md:col-6"> {{item.descripcionCorta}} - {{item.codBarras}}</div>
        <div class="col-12 md:col-5 text-center">
            <span class="number">
                <p-inputNumber [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal"
                    decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success" [min]="0"
                    [max]="100000" (onBlur)="getTotal()" (onInput)="getTotal()" [(ngModel)]="item.cantidad"
                    incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus">
                </p-inputNumber>
            </span>
        </div>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check" label="Cerrar" class="p-button p-button-danger"
            (click)="displaySummary=false;"></button>
    </ng-template>
</p-dialog>

<p-dialog header="INFORMACIÓN DEL CLIENTE" [(visible)]="displayInfoClient" [modal]="true" [closable]="false"
    [position]="'top'" [breakpoints]="{'960px': '75vw', '640px': '100vw'}">
    <p>Los campos seguidos de un * (asterisco) son obligatorios</p>
    <div class="p-inputgroup w-full mb-5">
        <div class="p-element p-inputgroup-addon"><label><i class="pi pi-search"></i></label></div>
        <div class="w-full">
            <p-autoComplete id="busqueda" [tabindex]="1" [suggestions]="resultsLsClients" size="small"
                (completeMethod)="searchItemClient($event)" field="razonSocial" [minLength]="1"
                (onSelect)="searchItemViewClient($event)" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                [(ngModel)]="fieldSearchClient" (onKeyUp)="clearFormCliente(true)" [showClear]="true"
                placeholder="Busqueda de cliente por nombre o identificación"></p-autoComplete>
        </div>
    </div>

    <form [formGroup]="formVenta">
        <div class="grid">
            <div class="w-full md:w-6 flex flex-wrap">
                <div class="w-full md:w-3 p-1">
                    <label class="pb-2">Tipo de identificación <span class="text-lg text-red-700">*</span></label>
                    <p-select [options]="listIdentificationType" optionLabel="descripcion" (onChange)="searchClient()"
                        placeholder="Tipo de identificación" formControlName="tipo" size="small"
                        class="{{this.formVenta.controls.tipo.valid && lockedFieldsIdClient ? 'disabledFillFields':''}}"></p-select>
                </div>
                <div class="w-full md:w-9 p-1">
                    <label class="pb-2">Nro. de identificación <span class="text-lg text-red-700">*</span> <span
                            class="text-xs" *ngIf="formVenta.value.tipo?.idTipoIdentificacion ==3">
                            Ingrese la información sin puntos y sin dígito de verificación</span></label>
                    <div class="p-inputgroup"><input pInputText type="text" class="w-full" pSize="small"
                            placeholder="Nro. de Identificación" formControlName="identificacion" autocomplete="off"
                            (keyup)="clearFormCliente()" (blur)="searchClient()"
                            class="{{lockedFieldsIdClient?'disabledFillFields':''}}">
                        <div class="p-inputgroup-addon">
                            <label>{{digito??''}}</label>
                        </div>
                    </div>

                </div>
            </div>

            <div class="w-full md:w-6 p-1" *ngIf="formVenta.value.tipo?.idTipoIdentificacion ==3">
                <label class="pb-2">Razón Social <span class="text-lg text-red-700">*</span></label>
                <input pInputText type="text" class="w-full uppercase" placeholder="Razon Social" size="small"
                    formControlName="razonSocial" autocomplete="off">
            </div>

            <div class="w-full md:w-6 p-1">
                <label class="pb-2">Contacto <span class="text-lg text-red-700">*</span></label>
                <input pInputText type="text" class="w-full uppercase" placeholder="Nombres y Apellidos" pSize="small"
                    formControlName="nombres" autocomplete="off">
            </div>
            <div class="w-full md:w-6 p-1">
                <label class="pb-2">Correo electrónico <span class="text-xs text-red-700">*</span></label>
                <input pInputText type="text" class="w-full lowercase" placeholder="Correo Electrónico" pSize="small"
                    formControlName="correo">
            </div>
            <div class="w-full md:w-6 p-1">
                <label class="pb-2">Nro. de teléfono</label>
                <input pInputText type="text" class="w-full" placeholder="Nro. de celular" pSize="small"
                    formControlName="telefono">
            </div>
            <div class="w-full text-xs text-center" *ngIf="listOfBrancheOffice.length == 1">
                <span class="pb-2 ">Sucursal: {{this.listOfBrancheOffice[0]?.sucursal}}</span>
            </div>
            <!--************************* Section Additional information **************************************-->
            <ul class="nav nav-tabs flex justify-content-center text-center alt-font" role="tablist">
                <li class="nav-item" role="presentation"><a data-bs-toggle="tab" (click)="divInfoADD=!divInfoADD"
                        class="nav-link {{divInfoADD?'active':''}}" aria-selected="false" role="tab" tabindex="-1"><i
                            class="pi pi-exclamation-circle text-2xl text-imex"></i>&nbsp;Información adicional (opcional)</a></li>
            </ul>
            <div class="w-full hidden-div {{divInfoADD?'show':''}}">
                <div class="w-full flex flex-wrap" style="height: fit-content; min-height:200px !important">
                    <div class="w-full md:w-6 p-1">
                        <label class="pb-2">Dirección</label>
                        <input pInputText type="text" class="w-full" placeholder="Dirección" pSize="small"
                            formControlName="direccion">
                    </div>
                    <div class="w-full md:w-6 p-1">
                        <label class="pb-2">Departamento</label>
                        <p-select [options]="listDptos" [filter]="true" optionLabel="nombreDepartamento"
                            placeholder="Departamento" formControlName="departamento" size="small" [checkmark]="true"
                            (onChange)="loadCities()"></p-select>
                    </div>
                    <div class="w-full md:w-6 p-1">
                        <label class="pb-2">Ciudad</label>
                        <p-select [options]="listCities" [filter]="true" optionLabel="nombreCiudad" size="small"
                            placeholder="Ciudad" formControlName="ciudad"></p-select>
                    </div>
                    <div class="w-full md:w-6 p-2" *ngIf="listOfBrancheOffice.length > 1">
                        <label class="pb-2 ">Sucursal</label>
                        <p-select [options]="listOfBrancheOffice" optionLabel="sucursal" size="small"
                            placeholder="Sucursal" formControlName="sucursal" class=""></p-select>
                    </div>
                </div>

            </div>

            <!--Section Channel New-->
            <div class="w-full p-1"
                *ngIf="listCanalIngreso.length > 0 && (selectedClient?.clienteProcedencia.length ==0 || clientIsNew)">
                <label class="pb-2">Procedencia <span class="text-xs text-red-700">*</span></label>
                <p-select [options]="listCanalIngreso" optionLabel="descripcion" class="w-full" size="small"
                    placeholder="Seleccione el canal de ingreso" formControlName="selectedChannelIngreso"></p-select>
            </div>
            <!--End Section-->
            <div class="mx-auto w-full text-right">
                <button pButton class="p-button p-button-danger" icon="pi pi-times-circle" label="No elegir cliente"
                    (click)="displayInfoClient=false; clearFormCliente(true)"></button>&nbsp;
                <button pButton class="p-button p-button-success" icon="pi pi-check" label="Continuar"
                    (click)="setInfoClient();"></button>
            </div>
        </div>
    </form>
</p-dialog>

<!--Información de sistema alterno-->
<p-dialog header="Cargar información de sistema alterno" [(visible)]="displayInfoTercero" [modal]="true">
    <div class="p-message p-message-info p-3">Se ha encontrado información en el sistema integrado, ¿Desea visualizar la
        información? <br><button pButton label="SI" icon="pi pi-check-circle" (click)="fillFormClientExternSystem()"
            class="p-button p-button-success"></button> | <button pButton label="NO" icon="pi pi-times-circle"
            class="p-button p-button-danger" (click)="displayInfoTercero=false;"></button></div>
</p-dialog>

<!--Importar información de ventas de e-commerce-->
<p-dialog header="Importar ventas gestionadas" [(visible)]="displayInfoECommerce" [modal]="true">
    <div class="flex flex-wrap">
        <div class="p-inputgroup w-full">
            <p-inputNumber buttonLayout="horizontal" spinnerMode="horizontal" class="w-full"
                [(ngModel)]="nroSalesECommerce" placeholder="Relacione el nro. de venta e-commerce" [autofocus]="true">
            </p-inputNumber>
            <button pButton label="Buscar" icon="pi pi-search" class="p-button p-button-success"
                (click)="getSaleECommerce()"></button>
        </div>
        <div class="w-full" *ngFor="let item of salesECommerce">
            <div class="w-full text-left pl-2s">
                <p><b>Tipo:</b> {{item.documentType}}<br>
                    <b>Identificación:</b> {{item.identification}}<br>
                    <b>Razón Social:</b> {{item.companyName}}<br>
                    <b>Contacto:</b> {{item.contact}}
                </p>
                <p><b>Email:</b> {{item.billingEmail}}<br>
                    <b>Dirección:</b> {{item.billingAddress}}<br>
                    <b>Ciudad:</b> {{item.billingCity}}<br>
                </p>
            </div>
            <div class="text-center w-full">
                <h4 class="text-uppercase m-0"><b>Totales</b></h4>
                # de items : {{item.detail.length}} |
                Subtotal : {{totales.subtotal | currency}} |
                Impuesto: {{totales.taxes | currency}}|
                Costo envio: {{totales.shippingCost | currency}}|<br>
                <b>TOTAL: {{(totales.subtotal + totales.taxes + totales.shippingCost) | currency}} </b>
            </div>
        </div>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-check-circle" label="Importar" *ngIf="salesECommerce.length > 0"
            class="p-button p-button-success" (click)="setDetailECommerce();"></button>
        <button pButton icon="pi pi-time-circle" label="Cerrar" class="p-button p-button-danger"
            (click)="displayInfoECommerce=false;"></button>
    </ng-template>
</p-dialog>
<!--<button (click)="setTemporal(142926)">Siiiiii</button>-->

<!--<app-footer></app-footer>-->

<!-- <script>
    window.addEventListener('beforeunload', (event) => {
      event.returnValue = `You have unsaved changes, leave anyway?`;
      localStorage.clear();
    });
  </script> -->